module.exports = __webpack_public_path__ + "img/lote-quarto.031f2337.jpg";